import PropTypes from 'prop-types';
import Head from 'next/head';

const ZHLPageHead = ({ description, title, ogDescription, ogTitle, ogImage, ogURL, canonicalURL }) => {
    const { currentDomain } = typeof window === 'undefined' ? {} : window.env;
    const canonicalHREF = canonicalURL?.[0] === '/' ? currentDomain + canonicalURL : canonicalURL;
    const ogURLHREF = ogURL?.[0] === '/' ? currentDomain + ogURL : ogURL;
    return (
        <Head key={title}>
            {/* for an explanation of why the meta viewport is set here: https://nextjs.org/docs/messages/no-document-viewport-meta */}
            <meta
                name="viewport"
                content="width=device-width,height=device-height,initial-scale=1.0,minimum-scale=1.0,user-scalable=yes"
            />
            {canonicalURL && <link rel="canonical" href={canonicalHREF} />}
            <meta name="description" content={description} />
            <title>{title}</title>
            <meta property="og:type" content="website" />
            <meta property="og:site_name" content="Zillow Home Loans" />
            {canonicalURL && <meta property="og:url" content={ogURLHREF ?? canonicalHREF} />}
            <meta property="og:title" content={ogTitle ?? title} />
            <meta property="og:description" content={ogDescription ?? description} />
            <meta property="og:image" content={ogImage} />
        </Head>
    );
};

ZHLPageHead.defaultProps = {
    ogImage: '/og_image-2019-04-02.png',
    title: 'Zillow Home Loans',
    description:
        'Introducing Zillow Home Loans. Buy the home you want with a lender you trust. Let us help you find the right mortgage for you.',
};

ZHLPageHead.propTypes = {
    canonicalURL: PropTypes.string,
    description: PropTypes.string,
    title: PropTypes.string,
    ogURL: PropTypes.string,
    ogDescription: PropTypes.string,
    ogTitle: PropTypes.string,
    ogImage: PropTypes.string,
};

export default ZHLPageHead;
